import React, { useEffect, useRef, useState } from 'react';
import { Card, Nav, Tab, Dropdown, Button, Modal } from 'react-bootstrap';
import { FaArrowDown } from 'react-icons/fa'; // React Icons for the arrow
import GroupTemplate from './Tabs/GroupTemplate';
import SmsTemplate from './Tabs/SmsTemplate';
import useApi from 'hooks/useApi';
import {
  createGroupTemplate,
  getGroupTemplate
} from 'api/endpoints/SmsCategory';
import { createSmsTemplate, getSmsTemplate } from 'api/endpoints/SmsTemplate';
import { get, isEmpty } from 'lodash';
import DynamicForm from 'screens/common/dynamicForm';
import { toast } from 'react-toastify';
import { formSubmissionToast } from 'helpers/utils';
import { getTenantFromToken } from 'utils/routeUtils';

function SmsManagement() {
  const tenant = getTenantFromToken();
  const childFetchRef = useRef(null); // To store child's fetch function

  const [activeTab, setActiveTab] = useState('group-templates');
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [smsTemplate, setSmsTemplate] = useState({});
  const [grouptemplate, setGroupTemplate] = useState({});
  const [editSmsTemplate, setEditSmsTemplate] = useState({});
  const [created, setCreated] = useState(false);
  const [groupTrigger, setGroupTrigger] = useState(false);
  const getSmsTemplateForm = useApi(getSmsTemplate);
  const getGroupTemplateForm = useApi(getGroupTemplate);
  const createSmsTemplateForm = useApi(createSmsTemplate);
  const createGroupTemplateForm = useApi(createGroupTemplate);

  useEffect(() => {
    getSmsTemplateForm.request({ tenant });
    getGroupTemplateForm.request({ tenant });
  }, [tenant, groupTrigger]);

  useEffect(() => {
    setSmsTemplate({});
    const tabledata = get(getSmsTemplateForm, 'data.results', []);
    // console.log(tabledata, 'smstemplate');
    setSmsTemplate(tabledata);
  }, [getSmsTemplateForm.data]);
  useEffect(() => {
    setGroupTemplate({});
    const tabledata = get(getGroupTemplateForm, 'data.results', []);
    // console.log(tabledata, 'grouptemplate');
    setGroupTemplate(tabledata);
  }, [getGroupTemplateForm.data]);

  const handleShowModal = type => {
    setGroupTemplate({});
    setSmsTemplate({});
    getSmsTemplateForm.request({ tenant });
    getGroupTemplateForm.request({ tenant });
    setModalType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType('');
  };

  const handleFormSubmit = async data => {
    const combinedData = { ...data };
    // console.log('Received combined data in parent:', combinedData);

    if (modalType === 'group-template') {
      // Submit data for group template
      try {
        const response = await createGroupTemplate({
          tenant,
          combinedData
        });
        setCreated(true);
        formSubmissionToast(response, toast, 'Category');
        handleCloseModal();
      } catch (err) {
        formSubmissionToast(err, toast, 'Category');
      }
    } else if (modalType === 'sms-message') {
      // Submit data for SMS message
      try {
        const response = await createSmsTemplate({
          tenant,
          combinedData
        });
        setCreated(true);
        formSubmissionToast(response, toast, 'Template');
        handleCloseModal();
      } catch (err) {
        formSubmissionToast(err, toast, 'Template');
      }
    }
  };

  useEffect(() => {
    const response = get(createSmsTemplateForm, 'data.results', []);
    setGroupTrigger(true);
  }, [createSmsTemplateForm.data]);

  useEffect(() => {
    const response = get(createGroupTemplateForm, 'data.results', []);
    setGroupTrigger(true);
  }, [createGroupTemplateForm.data]);

  const handleExport = () => {
    // console.log('Export action triggered');
    // Perform export logic
    // For example: Exporting data
  };

  return (
    <div>
      <div className="mb-4">
        <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link eventKey="group-templates">SMS Category</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="sms-messages">SMS Templates</Nav.Link>
            </Nav.Item>
            <Nav.Item className="ms-auto">
              <Dropdown align="end">
                <Dropdown.Toggle variant="primary" id="dropdown-create">
                  Create
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => handleShowModal('group-template')}
                  >
                    Create SMS Category
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleShowModal('sms-message')}>
                    Create SMS Template
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav.Item>
          </Nav>
          <Tab.Content className="mt-2">
            <Tab.Pane eventKey="group-templates">
              <GroupTemplate
                groupTrigger={groupTrigger}
                setGroupTrigger={setGroupTrigger}
                created={created}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="sms-messages">
              <SmsTemplate
                groupTrigger={groupTrigger}
                setGroupTrigger={setGroupTrigger}
                created={created}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>

      {/* Modal for Create Group Template or SMS Message */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === 'group-template'
              ? 'Create SMS Category'
              : 'Create SMS Template'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === 'group-template' && !isEmpty(grouptemplate) && (
            <DynamicForm
              key={'group-template'}
              data={grouptemplate} // Assuming grouptemplate contains form data for sms-message
              onSubmit={handleFormSubmit}
              modalType={'lg'}
            />
          )}
          {modalType === 'sms-message' && !isEmpty(smsTemplate) && (
            <DynamicForm
              key={'sms-message'}
              data={smsTemplate} // Assuming smsTemplate contains form data for group-template
              onSubmit={handleFormSubmit}
              modalType={'lg'}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SmsManagement;
